
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-09-30-scatterchart",
      function () {
        return require("private-next-pages/blogs/2021-09-30-scatterchart/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-09-30-scatterchart"])
      });
    }
  